/* ---------------------------------------------------------------------------
   MF AUDIT (Paket A, 28.09.2026) — gemeinsame Korrekturen, nur AUDIT-Theme 194573500682
   ---------------------------------------------------------------------------
   1) Sticky-Kaufleiste (CONV-03): blendet sich aus, solange das Kaufformular sichtbar ist (Sicherung gegen den
      IntersectionObserver des Themes, 8mm-Learning); html.mf-sticky-an zeigt an, dass die Leiste sichtbar ist.
   2) Link "Versandkosten" in der Preiszeile (TC-12): öffnet das Akkordeon "Versand & Rückgabe" (#mf-versand).
   3) Judge.me (SEO-02, UX-03): Widget-Titel als Überschrift Ebene 2 (role/aria-level), englische Labels
      "Previous/Next slide" und "Sort reviews by" deutsch. Gruppenhinweis (TC-03) per CSS.
   4) Tidio verzögert (PERF-02): Skript lädt erst nach der ersten Interaktion im Leerlauf (bzw. nach 3 s, wenn schon ein
      Tidio-Gespräch im Browser gespeichert ist). App-Embed im AUDIT-Theme deaktiviert (config/settings_data.json).
   Idempotent, ohne Abhängigkeiten, bricht nie die Seite.
--------------------------------------------------------------------------- */
(function () {
  'use strict';
  var DE = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('de') === 0;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function sicher(fn) { try { fn(); } catch (e) { /* nie die Seite blockieren */ } }

  /* ---------- 1) Sticky-Kaufleiste ---------- */
  /* MF-HEATMAP E1 (21.10.2026): mobil erscheint die Leiste schon, sobald gescrollt wird und der Kaufknopf nicht im Bild
     ist (vorher erst NACH dem Kaufknopf, ~1.600 px; laut Hotjar kamen ~70 % nie so weit). Ausgeblendet, solange der
     Kaufknopf sichtbar ist oder der Footer erreicht ist. Desktop unverändert (Theme-Logik). */
  function stickyLeiste() {
    var qa0 = document.querySelector('product-quick-add');
    if (!qa0) return;
    var formId = qa0.getAttribute('form');
    var root = document.documentElement;
    var mobil = window.matchMedia('(max-width: 699px)');
    var tick = false;
    /* Das Theme ersetzt Formular und Leiste beim Variantenwechsel (product:rerender): immer frisch suchen. */
    function qaEl() { return document.querySelector('product-quick-add'); }
    function formEl() { return document.getElementById(formId); }
    function sichtbar(el) {
      if (!el || !el.isConnected) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }
    function pruefen() {
      tick = false;
      var qa = qaEl(), form = formEl();
      if (!qa) return;
      var knopfSichtbar = sichtbar(form ? (form.querySelector('buy-buttons') || form) : null);
      var frueh = mobil.matches && window.scrollY > 120 && !knopfSichtbar && !sichtbar(document.querySelector('.footer'));
      root.classList.toggle('mf-qa-frueh', frueh);
      root.classList.toggle('mf-tidio', !!document.getElementById('tidio-chat'));
      if (mobil.matches) {
        root.classList.toggle('mf-qa-aus', !frueh);
      } else if (form) {
        root.classList.toggle('mf-qa-aus', form.getBoundingClientRect().bottom > 0);
      }
      root.classList.toggle('mf-sticky-an', frueh || (qa.classList.contains('is-visible') && !root.classList.contains('mf-qa-aus')));
    }
    function planen() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(pruefen);
      setTimeout(function () { if (tick) pruefen(); }, 200);
    }
    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen, { passive: true });

    /* Solange noch keine Auswahl getroffen ist (Seite ohne ?variant=, kein Variantenwechsel), führt der Leisten-Knopf zur
       Auswahl statt die vorausgewählte Variante (meist die kleinste Menge) in den Warenkorb zu legen. */
    function pickerEl() { return document.querySelector('.product-info__variant-picker'); }
    var picker0 = pickerEl();
    var gewaehlt = !picker0 || /[?&]variant=/.test(window.location.search);
    var legende = picker0 ? ((picker0.querySelector('fieldset legend') || {}).textContent || '') : '';
    var wahlText = /packungsgr|menge|quantity|size/i.test(legende) ? (DE ? 'Menge wählen' : 'Choose amount') : (DE ? 'Auswählen' : 'Choose');
    /* AUDIT 2026-11 DAR-01 (01.11.2026): Bei Kleidung sperrt snippets/mf-groesse-offen.liquid denselben Knopf mit
       „Bitte Größe wählen“ (data-mf-groesse-sperre). Beide Skripte haben auf die Textänderung des anderen reagiert und
       sich gegenseitig endlos überschrieben, die Seite fror ohne ?variant= ein. Gesperrte Knöpfe fasst diese Funktion
       deshalb nicht an; die Größen-Sperre hat Vorrang. Nach der Größenwahl setzt sperren() die Beschriftung zurück. */
    function knopfText() {
      var qa = qaEl();
      var b = qa && qa.querySelector('.mf-sticky-zeile buy-buttons button > div');
      if (!b) return;
      var knopf = b.closest('button');
      if (knopf && knopf.hasAttribute('data-mf-groesse-sperre')) return;
      if (!b.hasAttribute('data-mf-orig')) b.setAttribute('data-mf-orig', b.textContent);
      var soll = istGewaehlt() ? b.getAttribute('data-mf-orig') : wahlText;
      if (b.textContent !== soll) b.textContent = soll;
    }
    /* variant:change bubbelt vom Formular bis zum Dokument, product:rerender nicht: beides am Dokument bzw. per Observer. */
    /* detail.formId ist im Theme oft kein Text (form.id liefert das Feld name="id"), daher nur Text-IDs vergleichen. */
    document.addEventListener('variant:change', function (e) {
      var fid = e.detail && e.detail.formId;
      if (typeof fid === 'string' && fid !== formId) return;
      gewaehlt = true; knopfText(); setTimeout(pruefen, 50);
    });
    function istGewaehlt() {
      if (!gewaehlt && /[?&]variant=/.test(window.location.search)) gewaehlt = true;
      return gewaehlt;
    }
    document.addEventListener('click', function (e) {
      if (istGewaehlt() || !mobil.matches) return;
      var b = e.target.closest && e.target.closest('product-quick-add .mf-sticky-zeile buy-buttons button');
      var picker = pickerEl();
      if (!b || !picker) return;
      e.preventDefault();
      e.stopPropagation();
      var y = picker.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      picker.classList.add('mf-qa-hinweis');
      setTimeout(function () { picker.classList.remove('mf-qa-hinweis'); }, 1600);
    }, true);
    var bereich = qa0.closest('product-rerender') || qa0.parentNode;
    new MutationObserver(function () { knopfText(); planen(); }).observe(bereich, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    knopfText();
    pruefen();
  }

  /* ---------- 2) Versandkosten-Link ---------- */
  function versandOeffnen(scroll) {
    var d = document.getElementById('mf-versand');
    if (!d) return false;
    if (!d.open) {
      var s = d.querySelector('summary');
      if (s) s.click();
      if (!d.open) { d.open = true; d.setAttribute('aria-expanded', 'true'); }
    }
    if (scroll) d.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }
  function versandLink() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-mf-versand-link]') : null;
      if (!a) return;
      var h = a.getAttribute('href') || '';
      if (h.charAt(0) === '#' && versandOeffnen(true)) { e.preventDefault(); }
    });
    if (location.hash === '#mf-versand') setTimeout(function () { versandOeffnen(true); }, 400);
  }

  /* ---------- 3) Judge.me ---------- */
  // Nur Attribute, kein Umbau des App-DOM (Judge.me rendert das Widget selbst neu): Titel als Überschrift Ebene 2
  // für Screenreader; der Gruppenhinweis steht per CSS darunter (snippets/mf-audit-styles.liquid).
  function judgeme() {
    function anwenden() {
      sicher(function () {
        document.querySelectorAll('.jm-review-widget-minimal-header__title, .jdgm-rev-widg__title').forEach(function (t) {
          if (!/^H[1-6]$/.test(t.tagName) && t.getAttribute('role') !== 'heading') {
            t.setAttribute('role', 'heading');
            t.setAttribute('aria-level', '2');
          }
        });
        if (DE) {
          document.querySelectorAll('[aria-label="Previous slide"]').forEach(function (b) { b.setAttribute('aria-label', 'Vorherige Folie'); });
          document.querySelectorAll('[aria-label="Next slide"]').forEach(function (b) { b.setAttribute('aria-label', 'Nächste Folie'); });
          document.querySelectorAll('label.jdgm-visually-hidden').forEach(function (l) { if (l.textContent.trim() === 'Sort reviews by') l.textContent = 'Bewertungen sortieren nach'; });
        }
      });
    }
    anwenden();
    // Entprellt: höchstens alle 300 ms, nur solange App-Widgets nachladen (max. 20 s), damit die Hauptlast klein bleibt.
    var t = null;
    var mo = new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; anwenden(); }, 300);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); if (t) { clearTimeout(t); anwenden(); } }, 20000);
  }

  /* ---------- 4) Tidio verzögert ---------- */
  // Tidio (518 KB) lädt nicht mehr beim Seitenaufruf, sondern nach der ersten Interaktion (Scrollen, Tippen, Maus,
  // Taste), dann im Leerlauf des Browsers. Ist schon ein Tidio-Gespräch im Browser gespeichert, lädt es nach 3 s.
  // Das Widget selbst (Sichtbarkeit, Öffnungszeiten, Bot) bleibt unverändert in der Tidio-App gesteuert.
  // Live-Probe 28.09.2026: Im MAIN-Theme lädt Tidio beim Aufruf, zeigt mobil aber binnen 12 s keine sichtbare Blase.
  var TIDIO_SRC = 'https://code.tidio.co/uilgoylrcneeuh6txljbi59sdj300wm6.js';
  function tidioLaden() {
    if (window.tidioChatApi || document.querySelector('script[src*="code.tidio.co"]')) return;
    var s = document.createElement('script');
    s.src = TIDIO_SRC;
    s.async = true;
    document.body.appendChild(s);
  }
  function tidioVerzoegert() {
    if (window.tidioChatApi || document.querySelector('script[src*="code.tidio.co"]')) return;
    var gespeichert = false;
    sicher(function () {
      for (var i = 0; i < localStorage.length; i++) {
        if ((localStorage.key(i) || '').indexOf('tidio') === 0) { gespeichert = true; break; }
      }
    });
    if (gespeichert) { setTimeout(tidioLaden, 3000); return; }
    var events = ['scroll', 'pointerdown', 'touchstart', 'keydown', 'mousemove'];
    var los = false;
    function start() {
      if (los) return;
      los = true;
      events.forEach(function (ev) { window.removeEventListener(ev, start, true); });
      if ('requestIdleCallback' in window) requestIdleCallback(tidioLaden, { timeout: 4000 });
      else setTimeout(tidioLaden, 1500);
    }
    events.forEach(function (ev) { window.addEventListener(ev, start, { capture: true, passive: true }); });
  }

  ready(function () {
    sicher(stickyLeiste);
    sicher(versandLink);
    sicher(judgeme);
    sicher(tidioVerzoegert);
  });
})();
